import React from "react";
import {
  Dimensions,
  Button,
  View,
  ScrollView,
  Text,
  Platform,
} from "react-native";
import ManaBtn from "../components/ManaBtn";
import SvgCard from "../cards/svgcard";
import Footer from "../pages/v3/common/footer";
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import HomePageHeader from "./v3/home/HomePageHeader";
import { JournalProvider } from "./v3/journal/JournalContext";
import appStyles from "./appStyles";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

const isWeb = Platform.OS === "web";

class PageFeed {
  constructor(props) {
    this.controller = props.controller;
    this.feedview = null;
    this.onCardSubmit = this.cardSubmit.bind(this);
    this.pageArgs = {};
    this.editedFields = {};

    this.elements_dy = {};
    this.heightHeader = 0;
    this.heightFooter = 0;
    this.lastScrollTop = 0;

    this.titles = {};
    this.back_pages = {};

    this.scrollViewX = 0;
    this.scrollViewY = 0;
    this.scrollViewWidth = 0;
    this.scrollViewHeight = 0;
    this.scrollEvents = {};
    this.keyboardHeight = 0;
    this.keyboardScrollY = null;
  }

  onAvatarClick = () => {
    this.controller.cardAction({ action: "refresh" });
  };

  goToMore = () => {
    this.controller.changePage("feed", { selectedPage: "more", args: {} });
  };

  render() {
    const onLogout = this.onLogout.bind(this);
    const onOldFeed = this.onOldFeed.bind(this);
    const handleScroll = this.handleScroll.bind(this);
    const onLayout = this.onLayout.bind(this);

    const state = this.controller.state;
    const activities = state.activities;
    const userName = state.currentUser;
    const noData = activities == null;

    var debugHeader = false;
    var oldFeedLink = false;

    var deviceWidth = Dimensions.get("window").width;
    if (Platform.OS === "ios" && deviceWidth === 414) deviceWidth -= 45;
    const deviceHeight = Dimensions.get("window").height;

    // const cards2 = state.cardsTemplates == null || state.cardsVariables == null ?
    //     <Text/> : state.cardsVariables.map((item) => (item.is_visible == null || item.is_visible == 1) && <CustomCard key={item.card_key} name={item.card_type}
    //                                                              payload={state.cardsTemplates[item.card_type]}
    //                                                              variables={item} onSubmit={this.onCardSubmit}/>);

    if (state.cardsTemplates != null && state.cardsVariables != null) {
      //console.log(state.cardsVariables);
    }

    const uiV2 = this.controller.getUIVersion("feed") === "v2";

    const headerCards = ["SvgWhiteSpace", "SvgHeader"];
    const footerCards = ["SvgTimeSelector", "SvgFooter", "SvgWhiteSpace"];

    const width = isWeb ? Math.min(450, deviceWidth) : deviceWidth;
    const height = isWeb ? deviceHeight * 0.9 : deviceHeight * 0.975;

    const justify = isWeb ? "center" : "flex-end";
    this.heightHeader = 0;
    this.heightFooter = 0;

    for (var k in this.scrollEvents) delete this.scrollEvents[k];

    this.clearEditedFields(true);

    //const cards2 = state.cardsTemplates == null || state.cardsVariables == null ? <Text /> : state.cardsVariables.map((item) => (item.is_visible == null || item.is_visible == 1) && <CustomCard key={item.card_key} name={item.card_type} payload={state.cardsTemplates[item.card_type]} variables={item} onSubmit={this.onCardSubmit} /> );
    var header = this.getCards(
      state,
      headerCards,
      uiV2 ? ["SvgHeader", "SvgWhiteSpace"] : null,
      "header",
      width,
    );
    var cards = this.getCards(
      state,
      null,
      headerCards.concat(footerCards),
      null,
      width,
    );
    var footer = this.getCards(
      state,
      footerCards,
      uiV2 ? ["SvgFooter", "SvgWhiteSpace"] : null,
      "footer",
      width,
    );

    if (state.cardsVariables != null) {
      for (var i = 0; i < state.cardsVariables.length; i++) {
        const card = state.cardsVariables[i];
        const isNotShown =
          card.pages == null ||
          (card.pages !== "*" &&
            !card.pages.split(" ").includes(state.selectedPage));
        if (card.is_visible == null || card.is_visible || card.count_height) {
          if (!isNotShown && headerCards.includes(card.card_type)) {
            if (card.height != null && card.tag === "header") {
              this.heightHeader += 1 * card.height + 2;
            }
          }
          if (!isNotShown && footerCards.includes(card.card_type)) {
            if (card.height != null && card.tag === "footer") {
              this.heightFooter +=
                uiV2 && card.card_type === "SvgFooter"
                  ? 10
                  : 1 * card.height + 2;
            }
          }
        }
      }
    }

    const heightCards = height;
    const deltaY = isWeb ? 70 : 140;
    const deltaY2 = isWeb ? 100 : 40;
    const heightScrollView = uiV2
      ? heightCards - this.heightFooter - deltaY
      : heightCards - this.heightFooter - this.heightHeader;
    const heightView = uiV2 ? heightCards : heightCards;
    const heightInnerView = uiV2 ? heightView - deltaY2 : heightView;

    const style = uiV2
      ? [
          appStyles.container,
          {
            borderRadius: 4,
            paddingBottom: 110,
          },
        ]
      : { alignItems: "center", justifyContent: justify, flex: 1 };
    const userAvatar = this.controller.state
      ? this.controller.state.picture
      : null;

    return (
      <JournalProvider
        value={{
          controller: this.controller,
          onAvatarClick: this.onAvatarClick,
          goToMore: this.goToMore,
        }}
      >
        <View style={style}>
          {uiV2 ? (
            <HomePageHeader controller={this.controller} avatar={userAvatar} />
          ) : null}
          <View
            style={{ alignItems: "center", width: width, height: heightView }}
          >
            {debugHeader ? (
              <View style={{ width: 200 }}>
                <Button
                  onPress={onLogout}
                  title="Logout"
                  style={{
                    borderRadius: 2,
                    width: 200,
                    backgroundColor: "#0DAB76",
                  }}
                />
              </View>
            ) : null}
            {debugHeader ? (
              <Text style={{ fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-Regular" }) }}>{userName}</Text>
            ) : null}
            {oldFeedLink ? <Text> </Text> : null}
            {oldFeedLink ? (
              <ManaBtn onPress={onOldFeed} title="OLD FEED" />
            ) : null}

            {noData ? (
              <Text style={{ color: "#0DAB76" }}>Loading...</Text>
            ) : null}

            <View style={{ width: width, height: heightInnerView }}>
              {!uiV2 ? (
                <>
                  <View style={{ width: width, height: this.heightHeader }}>
                    {header}
                  </View>
                  <Text> </Text>
                </>
              ) : null}
              <ScrollView
                ref={(r) => (this.feedview = r)}
                onLayout={onLayout}
                onScroll={handleScroll}
                scrollEventThrottle={1}
                style={{ width: width, height: heightScrollView }}
              >
                {cards}
              </ScrollView>

              <View style={{ width: width, height: this.heightFooter }}>
                {footer}
              </View>
            </View>

            {uiV2 ? (
              <>
                <View
                  style={[
                    appStyles.footerOptions,
                    !isWeb ? { bottom: "14%" } : {},
                  ]}
                >
                  <Footer
                    controller={this.controller}
                    selectedPage={this.controller.state.selectedPage}
                  />
                </View>
              </>
            ) : null}
          </View>
        </View>
      </JournalProvider>
    );
  }

  keyboardWillShow(e) {
    const keyboardHeight = e.endCoordinates.height;
    if (this.keyboardHeight !== keyboardHeight) {
      console.log("Keyboard will show");
      this.keyboardHeight = keyboardHeight;
      if (false) {
        //set to false, event is triggered before focusing the element
        if (this.feedview != null) {
          this.feedview.scrollTo({
            x: 0,
            y:
              (this.lastScrollTop != null ? this.lastScrollTop : 0) +
              (this.keyboardHeight != null ? this.keyboardHeight : 0),
            animated: false,
          });
        }
      }
    }
  }

  keyboardWillHide(e) {
    if (this.keyboardHeight !== 0) {
      console.log("Keyboard will hide");
      if (
        this.feedview != null &&
        this.keyboardScrollY != null &&
        this.keyboardScrollY > 0
      ) {
        this.feedview.scrollTo({
          x: 0,
          y:
            (this.lastScrollTop != null ? this.lastScrollTop : 0) -
            this.keyboardScrollY,
          animated: false,
        });
      }
      this.keyboardHeight = 0;
      this.keyboardScrollY = null;
      this.onScroll(0, this.lastScrollTop);
    }
  }

  onLayout(event) {
    this.scrollViewX = event.nativeEvent.layout.x;
    this.scrollViewY = event.nativeEvent.layout.y;
    this.scrollViewWidth = event.nativeEvent.layout.width;
    this.scrollViewHeight = event.nativeEvent.layout.height;
    this.onScroll(0, this.lastScrollTop);
  }

  handleScroll(event) {
    const y = event.nativeEvent.contentOffset.y;
    this.lastScrollTop = y;
    this.onScroll(0, y);
  }

  onScroll(x, y) {
    Object.keys(this.scrollEvents).forEach((key) => {
      try {
        const handler = this.scrollEvents[key];
        if (handler != null) {
          const height =
            this.scrollViewHeight -
            (this.keyboardHeight != null && this.keyboardHeight > 0
              ? this.keyboardHeight - this.heightFooter
              : 0);
          handler(this.scrollViewWidth, height, x, y);
        }
      } catch (e) {
        console.log(e);
      }
    });
  }

  resetScroll() {
    if (this.feedview != null) {
      this.lastScrollTop = 0;
      console.log("Reset scroll");
      this.feedview.scrollTo({ x: 0, y: 0, animated: false });
    }
  }

  onPageUpdate() {
    this.scrollToSelection();
    this.onChangePageAction();
  }

  onBeforeChangePageAction(args) {
    if (args != null && args.onbeforechangepage != null) {
      this.onSvgAction(
        JSON.stringify({
          action: args.onbeforechangepage,
          args: args.onbeforechangepage_args,
        }),
      );
    }
  }

  onChangePageAction() {
    const state = this.controller.state;
    //console.log(state.screenArgs)
    if (
      state.screenArgs != null &&
      state.screenArgs.args != null &&
      state.screenArgs.args.onchangepage != null
    ) {
      const args = state.screenArgs.args;
      this.onSvgAction(
        JSON.stringify({
          action: args.onchangepage,
          args: args.onchangepage_args,
        }),
      );
    }
  }

  restoreEditedFields(keysToRestore) {
    const state = this.controller.state;
    if (
      state.screenArgs != null &&
      state.screenArgs.args != null &&
      state.screenArgs.args.variables != null
    ) {
      console.log("Restore edited fields");
      const vars = state.screenArgs.args.variables;

      //set inexistent keys, todo: refactor, remove if
      if (state.selectedPage === "amnesty_light") {
        const editedKeys = Object.keys(vars);
        for (let i in editedKeys) {
          const key = editedKeys[i];
          if (this.editedFields[key] === undefined) {
            this.editedFields[key] = vars[key];
          }
        }
      }

      //overwrite some keys
      const keys = keysToRestore; //Object.keys(this.editedFields);
      for (let i in keys) {
        const key = keys[i];
        if (vars[key] !== undefined) {
          this.editedFields[key] = vars[key];
        }
      }
    }
    //console.log(this.editedFields);
  }

  scrollToSelection() {
    if (this.feedview != null) {
      //TODO: clean up, this is way too complicated. need clear transitions and positions
      const state = this.controller.state;
      const el =
        state.screenArgs != null &&
        state.screenArgs.args != null &&
        state.screenArgs.args.scrollTo != null
          ? state.screenArgs.args.scrollTo
          : null;
      const dy =
        el != null && this.elements_dy != null && this.elements_dy[el] != null
          ? this.elements_dy[el]
          : null;
      const sdy =
        state.screenArgs != null &&
        state.screenArgs.args != null &&
        state.screenArgs.args.scrollDy != null
          ? parseInt(state.screenArgs.args.scrollDy, 10)
          : null;
      //el can be a hard value/number or an element reference
      const y = Number.isInteger(el)
        ? el
        : dy != null || sdy != null
        ? Math.max(
            0,
            (dy != null ? dy - this.heightHeader - 70 : 0) +
              (sdy != null ? sdy : 0),
          )
        : 0; //remove that hardcoded 70

      console.log("Scroll to " + el + " at " + y + " (" + dy + "," + sdy + ")");
      this.lastScrollTop = y;
      const fw = this.feedview;
      if (y != null)
        setTimeout(() => {
          try {
            console.log("Scroll to " + y);
            fw.scrollTo({ x: 0, y: y, animated: false }, 1);
          } catch (e) {}
        });
      this.onScroll(0, !!y ? y : 0);
    }
  }

  componentDidCatch(error, errorInfo) {
    console.log(error);
    console.log(errorInfo);
  }

  componentDidUpdate() {
    this.onScroll(0, this.lastScrollTop != null ? this.lastScrollTop : 0);
  }

  onLogout() {
    console.log("Logout!");
    this.controller.logout();
    this.changePage("welcome");
  }

  onOldFeed() {
    this.controller.changePage("oldfeed");
  }

  changePage(page, args, clearFields) {
    const state = this.controller.state;
    const oldPageArgs = this.pageArgs[state.selectedPage];
    if (oldPageArgs != null) {
      this.onBeforeChangePageAction(oldPageArgs);
    }

    if (!!clearFields) {
      this.clearEditedFields(false);
    }

    const targetPage = "feed";
    this.controller.changePage(targetPage, {
      selectedPage: page,
      args: args,
      lastScrollTop: this.lastScrollTop,
    });
  }

  cardSubmit = async (action) => {
    if (action.action === "more") {
      this.controller.confirmMore(action.id);
    } else if (action.action === "custom_sleep") {
      this.controller.customSleep(action.hour, action.id_type);
    } else {
      this.controller.cardAction(action);
    }
  };

  getGreeting() {
    const state = this.controller.state;
    var greeting = this.titles[state.selectedPage];
    if (state.impersonate != null && !state.impersonate.startsWith("omar"))
      greeting =
        "[!] " + state.impersonate.substring(0, state.impersonate.indexOf("@"));

    if (greeting == null) {
      var hrs = new Date().getHours();
      if (hrs < 12) greeting = "Good Morning!";
      else if (hrs >= 12 && hrs <= 17) greeting = "Good Afternoon!";
      else if (hrs >= 17 && hrs <= 24) greeting = "Good Evening!";
    }
    return greeting;
  }

  onAction(action) {
    //console.log("onAction " + JSON.stringify(action));
    this.cardSubmit(action);
  }

  onSvgFocus(data) {
    console.log(data);
    if (Platform.OS === "ios" || Platform.OS === "android") {
      if (
        data.pos.top + data.pos.height - this.lastScrollTop >
        this.scrollViewHeight - this.keyboardHeight
      ) {
        const targetY = this.lastScrollTop + this.keyboardHeight;
        this.keyboardScrollY = this.keyboardHeight;
        this.feedview.scrollTo({ x: 0, y: targetY, animated: false });
        this.onScroll(0, this.lastScrollTop);
      }
    }
  }

  onSvgAction(action) {
    try {
      //TODO: split to classes handling actions, unify and cleanup state transitions
      //console.log(action);
      const sourceFields = this.editedFields;
      if (sourceFields != null) {
        const keys = Object.keys(sourceFields);
        keys.forEach((k) => {
          if (sourceFields[k] != null) {
            action = action.replace(
              new RegExp("{" + k + "}", "g"),
              sourceFields[k],
            );
          }
        });
      }
      //console.log(action);

      const data = JSON.parse(action);

      if (data.action == null) {
        console.log("Ignoring, no action defined: " + action);
      } else if (data.action.toLowerCase() === "logout") {
        this.onLogout();
      } else if (data.action.toLowerCase() === "refresh") {
        const state = this.controller.state;
        var page = data.page != null ? data.page : state.selectedPage;
        if (
          state.selectedPage != null &&
          //TODO: mappings from server side
          (state.selectedPage.startsWith("new_") ||
            state.selectedPage.endsWith("_detail"))
        ) {
          page = "home";
        }
        var action = {};
        action["action"] = "requestpage";
        action["page"] = page;
        action["refresh"] = "all";
        if (this.pageArgs != null && this.pageArgs[page] != null)
          action["variables"] = this.pageArgs[page].variables;
        console.log("Retrieve items on refresh");
        this.controller.getItemsBulk(action, state.currentScreen, page, {
          lastScrollTop: this.lastScrollTop,
        });
        //this.controller.getItemsWithStats(state.currentScreen, page);
      } else if (data.action.toLowerCase() === "save") {
        this.pageArgs[data.page] = data.args;
        console.log("Save " + JSON.stringify(data));
        this.saveElement(data);
      } else if (data.action.toLowerCase() === "switch_input") {
        console.log("Switch input " + JSON.stringify(data));
        if (data.element_id != null) {
          const prevVal = this.editedFields[data.element_id];
          const values = data.values.split(" ");
          let value = null;
          for (var i = 0; i < values.length; i++) {
            if (values[i] !== prevVal) {
              value = values[i];
              break;
            }
          }
          console.log("Switching to " + value);
          this.updateInput(data.element_id, value, data.refresh);
        }
      } else if (data.action.toLowerCase() === "update_input") {
        console.log("Update input " + JSON.stringify(data));
        if (data.element_id != null) {
          this.updateInput(data.element_id, data.value, data.refresh);
        } else if (data.element_ids != null) {
          this.updateInputs(data.element_ids, data.values, data.refresh);
        }
      } else if (data.action.toLowerCase() === "update_selector") {
        console.log("Update selector " + JSON.stringify(data));
        if (data.element_id != null) {
          this.updateSelector(data.element_id, data.value, true);
        } else if (data.element_ids != null) {
          this.updateSelectors(data.element_ids, data.values);
        }
      } else if (data.action.toLowerCase() === "showselector") {
        const state = this.controller.state;
        if (data.page !== state.selectedPage) {
          const args = data.args != null ? data.args : {};
          args.edited_fields =
            this.editedFields != null
              ? JSON.parse(JSON.stringify(this.editedFields))
              : null;
          args.source_page = state.selectedPage;
          args.lastScrollTop = this.lastScrollTop;
          //console.log(data.page);
          this.pageArgs[data.page] = args;
          //console.log(this.pageArgs[data.page]);
        }
        this.changePage(data.page, data.args);
      } else if (data.action.toLowerCase() === "changepage") {
        const state = this.controller.state;
        //TODO: cleanup, this is v3 already. probably just need to merge args. need to split in classes and make code intelligible
        var clearFields = false;
        if (data.page !== state.selectedPage) {
          this.pageArgs[data.page] = data.args;
          //console.log(this.pageArgs[data.page]);
          clearFields = true;
        }
        this.changePage(data.page, data.args, clearFields);
      } else if (data.action.toLowerCase() === "impersonate") {
        const user =
          data.user != null && data.user.length > 0 ? data.user : null;
        this.controller.apiService.setImpersonate(user);
        this.controller.resetState(true, user);
        this.controller.getItemsWithStats("feed", "home");
      } else if (data.action.toLowerCase() === "requestpage") {
        this.pageArgs[data.page] = data.args;
        this.clearEditedFields(false);
        this.requestPage(data);
      } else if (data.action.toLowerCase() === "rerender") {
        const state = this.controller.state;
        var args = this.mergeVariables(state, data);
        if (data.timeout != null && data.timeout > 0) {
          const oldPage = state.selectedPage;
          this.queuedRerender = JSON.parse(JSON.stringify(args));
          if (this.rerenderTimeout != null) clearTimeout(this.rerenderTimeout);
          this.rerenderTimeout = setTimeout(() => {
            if (
              this.controller.state.selectedPage === oldPage &&
              this.queuedRerender != null
            ) {
              const renderArgs = this.queuedRerender;
              this.queuedRerender = null;
              this.changePage(state.selectedPage, renderArgs);
            }
          }, data.timeout);
        } else {
          this.pageArgs[state.selectedPage] = args;
          //console.log(args);
          this.changePage(state.selectedPage, args);
        }
      } else {
        this.onAction(data);
      }
    } catch (err) {
      console.log("Failed action " + action);
      console.log(err);
    }
  }

  clearEditedFields(restoreFromVars) {
    //keep reference
    const keysToRestore = JSON.parse(
      JSON.stringify(Object.keys(this.editedFields)),
    );

    console.log("Clear edited fields");
    //console.log(this.editedFields);
    for (var f in this.editedFields) {
      delete this.editedFields[f];
    }

    if (restoreFromVars) {
      this.restoreEditedFields(keysToRestore);
    }
  }

  updateInputs(element_ids, values, refresh) {
    const oldEditedFields =
      this.editedFields != null
        ? JSON.parse(JSON.stringify(this.editedFields))
        : null;
    for (var i = 0; i < element_ids.length; i++) {
      const doRefresh = !!refresh && i === element_ids.length - 1 ? 1 : 0;
      this.updateInput(element_ids[i], values[i], doRefresh, oldEditedFields);
    }
  }

  updateInput(element_id, value, refresh, oldEditedFields) {
    const input = isWeb ? document.getElementById(element_id) : null;
    //console.log(this.editedFields);
    if (isWeb && input != null) input.value = value;
    if (!isWeb || input != null) {
      var targetValue = value.toString();
      const sourceFields =
        oldEditedFields != null ? oldEditedFields : this.editedFields;
      if (sourceFields != null) {
        const keys = Object.keys(sourceFields);
        keys.forEach(
          (k) =>
            (targetValue = targetValue.replace(
              new RegExp("{" + k + "}", "g"),
              sourceFields[k],
            )),
        );
      }

      console.log("Update " + element_id + " " + targetValue);
      this.editedFields[element_id] = targetValue;
      //console.log("Edit " + element_id + " " + value);

      const updateScreenArgs = refresh === undefined || !!refresh;
      if (updateScreenArgs) {
        //this is confusing, need to unify page args with screen args, since we dropped pages
        const state = this.controller.state;
        if (
          state.screenArgs != null &&
          state.screenArgs.args != null &&
          state.screenArgs.args.variables != null
        ) {
          state.screenArgs.args.variables[element_id] = targetValue;
        }
      }

      if (refresh === undefined || !!refresh) {
        //console.log(state.screenArgs.args.variables);
        //console.log(this.editedFields);
        setTimeout(() => this.refreshOnInputChange(), 0);
      }
    } else {
      console.log("Error: trying to change inexistent input " + element_id);
    }
  }

  refreshOnInputChange(value) {
    const state = this.controller.state;
    const args = {
      variables: this.editedFields,
      scrollTo: this.lastScrollTop,
      backScrollTop:
        state.screenArgs != null ? state.screenArgs.lastScrollTop : undefined,
      lastScrollTop: this.lastScrollTop,
    };
    console.log("Refresh on input change");
    this.onSvgAction(JSON.stringify({ action: "rerender", args: args }));
  }

  updateSelectors(element_ids, values) {
    //console.log(element_ids); console.log(values);
    for (var i = 0; i < element_ids.length; i++) {
      const doRefresh = i === element_ids.length - 1 ? 1 : 0;
      //console.log(element_ids[i]); console.log(values[i])
      this.updateSelector(element_ids[i], values[i], doRefresh);
    }
  }

  updateSelector(element_id, value, refresh) {
    const state = this.controller.state;
    var prevArgs = this.pageArgs[state.selectedPage];
    prevArgs.edited_fields[element_id] = value;
    //console.log(prevArgs); console.log(element_id); console.log(value);

    if (!!refresh) {
      const state = this.controller.state;
      if (
        state.screenArgs != null &&
        state.screenArgs.args != null &&
        state.screenArgs.args.variables != null
      ) {
        state.screenArgs.args.variables[element_id] = value;
      }
      const typeSelectorArgs = this.pageArgs["type_selector"];
      if (typeSelectorArgs != null) typeSelectorArgs.processed = false;

      console.log(prevArgs.edited_fields);

      this.onSvgAction(
        JSON.stringify({
          action: "changepage",
          page: prevArgs.source_page,
          args: {
            variables: prevArgs.edited_fields,
            scrollTo: prevArgs.lastScrollTop,
            onchangepage: prevArgs.onchangepage,
          },
        }),
      );
    }
  }

  encKey() {
    //hack. we need a 3rd party safe store for the api secret
    const apiService = this.controller.apiService;
    //return apiService.user + ":" + apiService.config.API_SECRET
    return "abc123";
  }

  encryptField(value) {
    if (this.controller.privacyLevel > 0) {
      return "{enc:b64:" + AES.encrypt(value, this.encKey()).toString() + "}";
    } else {
      return value;
    }
  }

  decryptField(value) {
    let bytes = AES.decrypt(
      value.substring("{enc:b64:".length, value.length - 1),
      this.encKey(),
    );
    return bytes.toString(Utf8);
  }

  saveElement(data) {
    const target = data.target;
    const fields = data.fields;
    const encrypted_fields = data.encrypted_fields;
    const screen = data.screen;
    const page = data.page;
    const args = data.args;

    var action = {};
    if (fields === "*") {
      const fieldNames = Object.keys(this.editedFields);
      for (var i in fieldNames) {
        const fname = fieldNames[i];
        action[fname] =
          encrypted_fields != null && encrypted_fields.includes(fname)
            ? this.encryptField(this.editedFields[fname])
            : this.editedFields[fname];
      }
    } else if (fields != null) {
      var f = fields.split(" ");
      for (var i = 0; i < f.length; i++) {
        var fname = f[i].trim();
        if (data[fname] != null) {
          action[fname] =
            encrypted_fields != null && encrypted_fields.includes(fname)
              ? this.encryptField(data[fname])
              : data[fname];
        }
        if (this.editedFields[fname] != null) {
          action[fname] =
            encrypted_fields != null && encrypted_fields.includes(fname)
              ? this.encryptField(this.editedFields[fname])
              : this.editedFields[fname];
        }
      }
    }
    this.pageArgs["save:" + target] = action;

    action["action"] = "save";
    action["target"] = target;
    action["args"] = args;
    action["redirectScreen"] = screen;
    action["redirectPage"] = page;
    action["redirectArgs"] = { args: data.redirectArgs };

    this.controller.tracking.track("Edit Element");
    this.controller.cardAction(action);
  }

  requestPage(data) {
    const screen = data.screen;
    const page = data.page;
    const args = data.args;

    var action = {};
    action["action"] = "requestpage";
    action["page"] = page;
    if (args != null) action["page_args"] = args;

    this.controller.apiService.retryOnline(); //force online retry on pages that need server data
    console.log("Retrieve items on request page " + page);
    this.controller.getItemsBulk(action, screen, page, {
      lastScrollTop: this.lastScrollTop,
    });
  }

  mergeVariables(state, data) {
    var oldArgs = this.pageArgs[state.selectedPage];
    var args =
      oldArgs != null ? Object.assign({}, oldArgs, data.args) : data.args;
    if (oldArgs != null && oldArgs.variables != null) {
      var keys = Object.keys(oldArgs.variables);
      for (var j = 0; j < keys.length; j++) {
        if (args.variables[keys[j]] == null) {
          args.variables[keys[j]] = oldArgs.variables[keys[j]];
        }
      }
    }

    var newArgs = JSON.stringify(args);
    if (this.editedFields != null) {
      const keys = Object.keys(this.editedFields);
      keys.forEach(
        (k) =>
          (newArgs = newArgs.replace(
            new RegExp("{" + k + "}", "g"),
            this.editedFields[k],
          )),
      );
    }
    args = JSON.parse(newArgs);

    return args;
  }

  getCards(state, filter, exclude, filterTag, width) {
    const onAction = this.onAction.bind(this);
    const onSvgAction = this.onSvgAction.bind(this);
    const onSvgFocus = this.onSvgFocus.bind(this);

    var cards = [];
    //cards.push(<HeaderCard greeting={greeting} picture={state.picture}/>);
    if (state.cardsVariables == null) {
      cards.push(<Text />);
    } else {
      for (var i = 0; i < state.cardsVariables.length; i++) {
        var def = JSON.parse(JSON.stringify(state.cardsVariables[i])); //clone definition, we'll add variables

        if (filterTag != null && def.tag !== filterTag) {
          continue;
        }

        this.updateCardsLocally(def, state);

        const isVisible = def.is_visible == null || def.is_visible == 1;
        const isNotShown =
          def.pages == null ||
          (def.pages !== "*" &&
            !def.pages.split(" ").includes(state.selectedPage));

        if (isVisible && !isNotShown) {
          var cardType = def.card_type;
          if (
            (filter != null && !filter.includes(cardType)) ||
            (exclude != null && exclude.includes(cardType))
          ) {
            continue;
          }

          if (cardType.substring(0, 3).toLowerCase() == "svg") {
            //TODO: simplify, split to classes, make a clearer override mechanism
            this.overrideWithPageArgs(state);

            //TODO: move to separate class, maybe package
            if (
              state.svgTemplates != null &&
              state.svgTemplates[cardType] != null
            ) {
              //console.log("Rendering card " + cardType);
              var code = state.svgTemplates[cardType];

              this.fillVariables(def, state);
              code = this.renderChildSvgs(code, def);

              code = this.computeSelectors(code, def);
              code = this.computeAdditions(code, def);
              //code = this.replaceEditedFields(code);
              code = this.replaceEmojis(code);
              code = this.replaceEncryptedCode(code);

              this.renderCards(
                isWeb,
                cards,
                code,
                def,
                onSvgAction,
                onSvgFocus,
                width,
              );
            }
          }
        }
      }
    }
    //cards.push(<FooterCard/>);
    return cards;
  }

  replaceEditedFields(code, def) {
    var evaluated = code;
    if (this.editedFields != null) {
      var keys = Object.keys(this.editedFields);
      for (var i = 0; i < keys.length; i++) {
        evaluated = evaluated.replace(
          new RegExp("{" + keys[i] + "}", "g"),
          this.editedFields[keys[i]],
        );
      }
    }
    return evaluated;
  }

  overrideWithPageArgs(state) {
    if (
      state.screenArgs != null &&
      state.screenArgs.args != null &&
      state.screenArgs.args.overrides != null
    ) {
      const overrides = state.screenArgs.args.overrides;
      var cardKeys = Object.keys(state.cardsVariables);
      var overrideKeys = Object.keys(overrides);
      for (var i = 0; i < cardKeys.length; i++) {
        const cardKey = cardKeys[i];
        for (var k = 0; k < overrideKeys.length; k++) {
          var idx = overrideKeys[k];
          state.cardsVariables[cardKey][idx] = overrides[idx];
        }
      }
    }
  }

  updateCardsLocally(def, state) {
    if (def.card_type === "SvgError") {
      def.is_visible = state.error != null && state.error.length > 0 ? 1 : 0;
      def.error = state.error;
      def.error_element = state.error_element;
    }
  }

  renderCards(isWeb, cards, code, def, onSvgAction, onSvgFocus, width) {
    const outputVariables = this.editedFields;
    const elements_dy = this.elements_dy;
    const scrollEvents = this.scrollEvents;
    const scrollWidth = this.scrollViewWidth;
    const scrollHeight = this.scrollViewHeight;
    const footerHeight = 50;

    if (isWeb) {
      cards.push(
        <SvgCard
          width={width}
          key={def.card_type}
          code={code}
          vars={def}
          onAction={onSvgAction}
          onFocus={onSvgFocus}
          outputVariables={outputVariables}
          elements_dy={elements_dy}
          scrollEvents={scrollEvents}
        />,
      );
    } else {
      cards.push(
        <SvgCard
          width={width}
          key={def.card_type}
          code={code}
          vars={def}
          onAction={onSvgAction}
          onFocus={onSvgFocus}
          outputVariables={outputVariables}
          scrollWidth={scrollWidth}
          scrollHeight={scrollHeight}
          scrollEvents={scrollEvents}
          footerHeight={footerHeight}
          elements_dy={elements_dy}
        />,
      );
    }
  }

  renderChildSvgs(code, def) {
    var keys = Object.keys(def);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].startsWith("svg:")) {
        var element = def[keys[i]];
        var data = def[element];
        console.log("Rendering child " + keys[i] + " as " + element);

        if (Array.isArray(data)) {
          var childs = "";
          var k = Object.keys(data);
          var itemHeight = def["item:height"];
          var itemMinCount = def["item:mincount"];
          if (itemHeight != null) {
            for (var j = 0; j < k.length; j++) {
              var dy = j * itemHeight;
              childs += data[j].replace(new RegExp("{item:dy}", "g"), dy);
            }
            while (code.includes("{" + keys[i] + "}")) {
              code = code.replace("{" + keys[i] + "}", childs);
            }
            var itemCount = Math.max(
              k.length,
              itemMinCount != null ? itemMinCount * 1 : 0,
            );
            def["height"] = Math.max(
              this.scrollViewHeight != null ? this.scrollViewHeight : 0,
              def["height"] * 1 + itemCount * itemHeight,
            );
            def["height_" + keys[i]] = itemCount * itemHeight;
            def["count_" + keys[i]] = k.length;
            def["dy_footer"] = itemCount * itemHeight; //TODO: remove after everyone upgraded on mobile
          }
        } else {
          while (code.includes("{" + keys[i] + "}")) {
            code = code.replace("{" + keys[i] + "}", data);
          }
        }
      }
    }

    return code;
  }

  generateChildCard(code, def) {
    var keys = Object.keys(def);
    for (var i = 0; i < keys.length; i++) {
      while (code.includes("{" + keys[i] + "}")) {
        code = code.replace("{" + keys[i] + "}", def[keys[i]]);
      }
    }
    return code;
  }

  fillVariables(def, state) {
    this.expandHours(def);
    this.decryptVariables(def);

    if (def.titles != null && def.titles.length > 0) {
      var titles = JSON.parse(def.titles);
      var tk = Object.keys(titles);
      for (var k = 0; k < tk.length; k++) {
        this.titles[tk[k]] = titles[tk[k]];
      }
    }

    if (def.back_pages != null && def.back_pages.length > 0) {
      var back_pages = JSON.parse(def.back_pages);
      var tk = Object.keys(back_pages);
      for (var k = 0; k < tk.length; k++) {
        this.back_pages[tk[k]] = back_pages[tk[k]];
      }
    }

    def["profile_picture"] = state.picture;
    def["greeting"] = this.getGreeting();
    def["lastScrollTop"] =
      this.controller.state.screenArgs != null &&
      this.controller.state.screenArgs.lastScrollTop != null
        ? this.controller.state.screenArgs.lastScrollTop
        : this.lastScrollTop; //previous screen scroll state

    var selectedPage = this.controller.state.selectedPage;
    if (selectedPage == null) selectedPage = "home";
    def["color_home"] = "home" === selectedPage ? "#0DAB76" : "#8A8A8F";
    def["color_activities"] =
      "activities" === selectedPage ? "#0DAB76" : "#8A8A8F";
    def["color_tags"] = "tags" === selectedPage ? "#0DAB76" : "#8A8A8F";
    def["color_reflection"] = selectedPage.includes("reflection")
      ? "#0DAB76"
      : "#8A8A8F";
    def["color_resolution"] = selectedPage.includes("resolution")
      ? "#0DAB76"
      : "#8A8A8F";
    def["color_more"] = "more" === selectedPage ? "#0DAB76" : "#8A8A8F";

    var backPage = this.back_pages[selectedPage];
    if (backPage == null && selectedPage !== "home") backPage = "home";
    def["back_page"] = backPage;
    def["display_back"] = backPage != null ? "inline" : "none";
    def["display_back_reversed"] = backPage == null ? "inline" : "none";

    if (
      state.screenArgs != null &&
      state.screenArgs.args != null &&
      state.screenArgs.args.variables != null
    ) {
      var k = Object.keys(state.screenArgs.args.variables);
      for (var j = 0; j < k.length; j++) {
        var varKey = k[j];
        var value = state.screenArgs.args.variables[varKey];

        //hackish, need a nice solution
        const isCheckbox = varKey.includes("_is_");
        def[varKey] = isCheckbox
          ? !value || value === "false"
            ? ""
            : "checked"
          : value;
      }
    }

    var filter = def["filter"];
    if (filter != null) filter = filter.toLowerCase();

    var defk = Object.keys(def);
    for (var i = 0; i < defk.length; i++) {
      var val = def[defk[i]];
      if (val == null || val.startsWith == null) {
        continue;
      }

      var card = null;
      if (val.startsWith("card=")) {
        const idxE = val.indexOf(":");
        if (idxE >= 0) {
          const idxS = "card=".length;
          const cardVar = val.substr(idxS, idxE - idxS);
          card = def[cardVar];
          val = val.substr(idxE + 1);
        }
      }

      var isFiltered = false;
      if (val.startsWith("filtered:")) {
        val = val.substr("filtered:".length);
        isFiltered = true;
      }
      var isJson = false;
      if (val.startsWith("json:")) {
        val = val.substr("json:".length);
        val = JSON.parse(val);
        isJson = true;
      }

      if (isJson) {
        var result = [];
        var keys = Object.keys(val);
        for (var j = 0; j < keys.length; j++) {
          if (
            !isFiltered ||
            filter == null ||
            keys[j] == null ||
            keys[j].toLowerCase().includes(filter)
          ) {
            //console.log("Including " + keys[j]);
            var data = val[keys[j]];
            if (card != null) {
              data = this.generateChildCard(card, JSON.parse(data));
            }

            result.push(this.replaceEmojis(data));
          }
        }
        def[defk[i]] = result;
      } else {
        if (card != null) {
          val = this.generateChildCard(card, JSON.parse(data));
        }
        def[defk[i]] = this.replaceEmojis(val);
      }
    }
  }

  replaceEmojis(source) {
    var code = source;
    var idx = code.indexOf("{emoji:");
    while (idx >= 0) {
      const len = code.length;
      var idxE = idx + 1;
      var q = 1;
      while (idxE < len && q > 0) {
        if (code[idxE] === "{") q++;
        if (code[idxE] === "}") q--;
        if (q === 0) break;
        idxE++;
      }
      const expr = code.substring(idx + 1, idxE); //TODO: add parsing if needed, to be able to pass variables here
      var emoji = "";
      if (expr.length > 0) {
        const emojiCode = expr.substring(6);
        if (isWeb || true) {
          const url =
            this.controller.apiService.getUrl() + "/emoji?" + emojiCode;
          emoji =
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 36 36"><image xlink:href="' +
            url +
            '" width="36" height="36"/></svg>';
        } else {
          //emoji = require('./data/emoji/' + emojiCode + ".svg");
        }
      }
      code = code.substring(0, idx) + emoji + code.substring(idxE + 1);
      idx = code.indexOf("{emoji:");
    }
    return code;
  }

  computeSelectors(source, def) {
    //quick solution for if/else selectors in svgs. to replace at a later date with a proper parser and a nicer syntax
    var code = source;
    var idx = code.indexOf("{?");
    const len = code.length;
    while (idx >= 0 && idx < len) {
      var idxE = idx + 1;
      var q = 1;
      while (idxE < len && q > 0) {
        if (code[idxE] === "{") q++;
        if (code[idxE] === "}") q--;
        if (q === 0) break;
        idxE++;
      }
      const cond = code.substring(idx + 2, idxE);

      var evaluated = cond;
      var keys = Object.keys(def); //TODO: optimize, drop loop in loop
      for (var i = 0; i < keys.length; i++) {
        evaluated = evaluated.replace(
          new RegExp("{" + keys[i] + "}", "g"),
          def[keys[i]],
        );
      }

      const f = evaluated.split(/[=<>\?:]/);
      const sep = evaluated.match(/[!=<>\?:]/);
      //console.log(f); console.log(sep);
      if (f.length === 4) {
        var check;
        if (sep[0] === "<") check = f[0] * 1 < f[1] * 1;
        else if (sep[0] === ">") check = f[0] * 1 > f[1] * 1;
        else check = f[0] === f[1];
        source = source.replace("{?" + cond + "}", check ? f[2] : f[3]);
      }

      idx = idxE < len ? code.indexOf("{?", idxE) : len;
    }
    return source;
  }

  computeAdditions(source, def) {
    //quick hack. to replace at a later date with a proper parser and a nicer syntax
    var code = source;
    var idx = code.indexOf("{+");
    const len = code.length;
    while (idx >= 0 && idx < len) {
      var idxE = idx + 1;
      var q = 1;
      while (idxE < len && q > 0) {
        if (code[idxE] === "{") q++;
        if (code[idxE] === "}") q--;
        if (q === 0) break;
        idxE++;
      }
      const cond = code.substring(idx + 2, idxE);

      var evaluated = cond;
      var keys = Object.keys(def); //TODO: optimize, drop loop in loop
      for (var i = 0; i < keys.length; i++) {
        evaluated = evaluated.replace(
          new RegExp("{" + keys[i] + "}", "g"),
          def[keys[i]],
        );
      }

      const f = evaluated.split(/[\+]/);
      //console.log(f); console.log(sep);
      var v = 0;
      for (var i in f) v = v + 1 * f[i];
      source = source.replace("{+" + cond + "}", v);

      idx = idxE < len ? code.indexOf("{+", idxE) : len;
    }
    return source;
  }

  replaceEncryptedCode(source) {
    var code = source;
    var idx = code.indexOf("{enc:b64:");
    const len = code.length;
    while (idx >= 0 && idx < len) {
      var idxE = idx + 1;
      var q = 1;
      while (idxE < len && q > 0) {
        if (code[idxE] === "{") q++;
        if (code[idxE] === "}") q--;
        if (q === 0) break;
        idxE++;
      }
      const cond = code.substring(idx, idxE + 1);
      var dec = this.decryptField(cond);
      const isQuoted =
        idx > 0 &&
        code[idx - 1] === '"' &&
        idxE + 1 < code.length &&
        code[idxE + 1] === '"';
      if (isQuoted) {
        dec = dec
          .replace(new RegExp("'", "g"), "&amp;apos;")
          .replace(new RegExp('"', "g"), "&amp;quot;");
      }
      source = source.replace(cond, dec);
      idx = idxE < len ? code.indexOf("{enc:b64:", idxE) : len;
    }

    return source;
  }

  decryptVariables(def) {
    var keys = Object.keys(def);
    for (var i = 0; i < keys.length; i++) {
      const val = def[keys[i]];
      if (val != null && val.toString().includes("{enc:b64:")) {
        def[keys[i]] = this.replaceEncryptedCode(val);
      }
    }
  }

  expandHours(def) {
    //TODO: get from server, we need to be card agnostic
    def["IMG_URL"] = this.controller.apiService.getUrl() + "/image?";
    if (def["hour"] != null) {
      def["hour_time"] = def["hour"].substring(0, def["hour"].indexOf(" "));
      def["hour_ampm"] = def["hour"].substring(def["hour"].indexOf(" ") + 1);
    }
    if (def["hour_next"] != null) {
      def["hour_next_time"] = def["hour_next"].substring(
        0,
        def["hour_next"].indexOf(" "),
      );
      def["hour_next_ampm"] = def["hour_next"].substring(
        def["hour_next"].indexOf(" ") + 1,
      );
    }
    if (def["target_hour"] != null) {
      def["target_hour_time"] = def["target_hour"].substring(
        0,
        def["target_hour"].indexOf(" "),
      );
      def["target_hour_ampm"] = def["target_hour"].substring(
        def["target_hour"].indexOf(" ") + 1,
      );
    }
  }
}

export default PageFeed;
